// One campaign, drilled: adsets -> ads with review state and the SAME
// serving-eligibility verdict delivery uses (computed server-side from the
// RTB gate — published + active×3 + approved + live creative).
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { campaignService } from '../../services/api';
import './Campaigns.css';

export default function CampaignDetail() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await campaignService.get(id);
        if (!cancelled) { setData(res.data); setError(null); }
      } catch (e) { if (!cancelled) setError(e.response?.data?.error || e.message); }
    })();
    return () => { cancelled = true; };
  }, [id]);

  if (error) return <div className="cp-page"><div className="alert alert-error">{error}</div></div>;
  if (!data) return <div className="cp-page"><div className="cp-empty">Loading…</div></div>;

  const { campaign, rows, open_change_request: openCr } = data;
  const adsets = [];
  for (const r of rows) {
    let g = adsets.find((a) => a.adset_id === r.adset_id);
    if (!g) { g = { adset_id: r.adset_id, adset_name: r.adset_name, adset_status: r.adset_status, ads: [] }; adsets.push(g); }
    if (r.ad_id) g.ads.push(r);
  }

  return (
    <div className="cp-page">
      <div className="page-header">
        <Link to="/campaigns" className="cp-back">← Campaigns</Link>
        <h1>{campaign.campaign_name}</h1>
        <p className="cp-sub">
          {campaign.tenant_name} · <span className="status-badge">{campaign.campaign_status}</span>
          {' '}· {campaign.is_published ? 'published' : 'never published'}
        </p>
      </div>

      {openCr && (
        <div className="alert alert-error">
          Open change request ({openCr.status}) by {openCr.submitted_by_name || '—'} —{' '}
          <Link to="/moderation?queue=change-requests">review it in Moderation</Link>
        </div>
      )}

      {adsets.length === 0 && <div className="cp-empty">No adsets.</div>}
      {adsets.map((s) => (
        <div className="cp-adset" key={s.adset_id}>
          <div className="cp-adset-head">
            {s.adset_name} <span className="status-badge">{s.adset_status}</span>
            {s.ads[0]?.start_date && (
              <span className="cp-flight">
                {new Date(s.ads[0].start_date).toLocaleDateString()} → {s.ads[0].end_date ? new Date(s.ads[0].end_date).toLocaleDateString() : 'open'}
              </span>
            )}
          </div>
          {s.ads.length === 0 ? <div className="cp-none">No ads.</div> : (
            <table className="data-table cp-table">
              <thead>
                <tr><th>Ad</th><th>Type</th><th>Status</th><th>Review</th><th>Creative</th><th>Serving?</th></tr>
              </thead>
              <tbody>
                {s.ads.map((a) => (
                  <tr key={a.ad_id}>
                    <td>{a.ad_name}</td>
                    <td>{a.ad_type}</td>
                    <td><span className="status-badge">{a.ad_status}</span></td>
                    <td>
                      <span className={`cp-review cp-${a.review_status}`}>{a.review_status}</span>
                      {a.review_status === 'disapproved' && a.review_feedback?.reasons?.length > 0 && (
                        <div className="cp-feedback">{a.review_feedback.reasons.join('; ')}</div>
                      )}
                    </td>
                    <td>{a.creative_name ? `${a.creative_name}${a.creative_live ? '' : ' (not live)'}` : '—'}</td>
                    <td>{a.serving_eligible
                      ? <span className="cp-serving">yes</span>
                      : (
                        <span className="cp-notserving" title="Requires: campaign published + campaign/adset/ad active + review approved + a live creative + inside the adset flight window">
                          no{a.in_flight === false ? ' (out of flight)' : ''}
                        </span>
                      )}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      ))}
    </div>
  );
}
